var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-founders",attrs:{"id":"from-the-founders"}},[_c('ProductsFoundersContainer',{attrs:{"product-url":_vm.parseUrl,"posts":_vm.founders.posts,"links":_vm.founders.links,"is-select":_vm.isSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }